const extractValue = function (objFhir, propertyStr) {
    try {
        const firstParam = propertyStr.substring(0, propertyStr.indexOf('.'));
        const residual = propertyStr.substring(propertyStr.indexOf('.') + 1);
        if (firstParam) {
            return extractValue(objFhir[firstParam], residual);
        } else {
            return objFhir[residual];
        }
    } catch {
        return undefined;
    }
};

const extractValueByArray = function (objFhir, propertyStrArray, propertyStrEqual, value, propertyStrReturn) {
    const arrayValue = extractValue(objFhir, propertyStrArray);
    if (arrayValue instanceof Array) {
        const arrayValueReturn = arrayValue.filter((objValue) => {
            const valueExtract = extractValue(objValue, propertyStrEqual); // Valor vindo do objeto fhir
            if (valueExtract === undefined) return false;
            return valueExtract.includes(value);
        });
        if (arrayValueReturn.length > 1) console.log(`Não está extraindo o segundo valor da propriedade ${propertyStrEqual}`);
        if (arrayValueReturn.length > 0) {
            return extractValue(arrayValueReturn[0], propertyStrReturn);
        }
        return undefined;
    } else {
        return undefined;
    }
};

const extractValuesByArray = function (objFhir, propertyStrArray, propertyStrEqual, value, propertyStrReturn) {
    const arrayValue = extractValue(objFhir, propertyStrArray);
    if (arrayValue instanceof Array) {
        const foundObjs = arrayValue.filter((objValue) => {
            const valueExtract = extractValue(objValue, propertyStrEqual); // Valor vindo do objeto fhir
            if (valueExtract === undefined) return false;
            return valueExtract.includes(value);
        });
        let values = [];
        foundObjs.forEach((foundObj) => {
            values.push(extractValue(foundObj, propertyStrReturn));
        });
        return values.length > 0 ? values : undefined;
    } else {
        return undefined;
    }
};

const extractArrayObjectByArray = function (objFhir, arrayProperties) {
    let result = [];
    arrayProperties.forEach((properties) => {
        const [key, propertyStrArray, propertyStrEqual, value, propertyStrReturn] = properties;
        const valuesInterno = extractValuesByArray(objFhir, propertyStrArray, propertyStrEqual, value, propertyStrReturn);
        if (valuesInterno === undefined) return;
        valuesInterno.forEach((value, i) => {
            if (result[i] === undefined) result[i] = {};
            result[i][key] = value;
        });
    });
    if (result.length == 0) return undefined;
    return result;
};

module.exports = { extractValue, extractValueByArray, extractValuesByArray, extractArrayObjectByArray };
